import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d597af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-progress-parent" }
const _hoisted_2 = { class: "navbar-progress" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item,
          onClick: ($event: any) => (_ctx.onClick(index)),
          class: _normalizeClass([{ current: index === _ctx.currentTab }, { done: item.done }])
        }, [
          _createElementVNode("span", null, _toDisplayString(item.name), 1),
          _hoisted_4
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}